import React from 'react';
import { Box, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import UalabiLogo from '../assets/Ualabi_logo.svg';

const Banner = ({ title, subtitle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box
      sx={{
        py: 8,
        bgcolor: 'background.default',
        textAlign: 'center'
      }}
    >
      <Container>
        <Box
          component="img"
          src={UalabiLogo}
          alt="Ualabi Logo"
          sx={{
            mx: 'auto',
            width: isMobile ? 150 : 300,
            height: isMobile ? 150 : 300,
            mb: 4,
            display: 'block'
          }}
        />
        <Typography 
          variant="h1"
          component="h1" 
          sx={{ 
            mb: 2,
            color: 'grey.400',
          }}
        >
          {title}
        </Typography>
        <Typography 
          variant="h5" 
          component="h2" 
          sx={{ 
            mb: 4,
            maxWidth: '800px',
            mx: 'auto',
            color: 'text.primary',
          }}
        >
          {subtitle}
        </Typography>
      </Container>
    </Box>
  );
};

export default Banner;